import { render, staticRenderFns } from "./title.vue?vue&type=template&id=45952f34&"
import script from "./title.vue?vue&type=script&lang=js&"
export * from "./title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarTitle})
